import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTheme } from "@mui/material";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";

type NoChatsAvailableProps = {
  message: string;
};

export const NoChatsAvailable: React.FC<NoChatsAvailableProps> = ({ message }) => {
  const {
    palette: {
      primary: { main },
    },
  } = useTheme();

  return (
    <MDBox display="flex" flexDirection="column" alignItems="center" justifyContent="center">
      <InfoOutlinedIcon sx={{ fontSize: 60, color: main, marginBottom: 2 }} />
      <MDTypography variant="body1"> {message} </MDTypography>
    </MDBox>
  );
};
